import { FC } from 'react';
import { DownOutlined } from '@ant-design/icons';
import { ProButton, ProDropdown } from '../antd';
import { BaseOperationDropdownProps } from './interface';

/** 下拉按钮组 */
const Dropdown: FC<BaseOperationDropdownProps> = props => {
  const { children, text, beforeIcon, icon, ...restProps } = props;
  return (
    <ProDropdown trigger={['click']} {...restProps}>
      {children || (
        <ProButton icon={beforeIcon}>
          {text}
          {icon}
        </ProButton>
      )}
    </ProDropdown>
  );
};

Dropdown.defaultProps = {
  text: '批量操作',
  icon: <DownOutlined />,
};

export default Dropdown;